class ZoneService {
  constructor(serviceBase) {
    this.serviceBase = serviceBase;
  }

  getList(params) {
    return this.serviceBase.getList(params);
  }

  getSelectOptions(params) {
    return this.serviceBase.getResourceAction('select-options', params);
  }
}

export default ZoneService;



// WEBPACK FOOTER //
// ./src/services/ZoneService.js